var $ajaxOverlay = $("#js-project-overlay"),
    $closeAjaxButton = $("#project-overlay__close-btn"),
    $ajaxHolder = $("#project-overlay__ajax-holder"),
    ajaxOpen = false,
    originalHref,
    ajaxHref,
    $loader = $("#project-overlay__loader");
//ajax for cards
// $(document).on("click", ".js-open-project", function (e) { 
//     e.preventDefault(); 

//     openProjectAjax();

    
// });

$(".js-open-project").on("click", function(e){
    e.preventDefault(); 
    ajaxHref = $(this).attr("href");
    openProjectAjax(ajaxHref);
});

function openProjectAjax(ajaxHref) {
    $loader.show();

    //ajaxHref = $(this).attr("href"); //console.log(ajaxHref);
    ajaxOpen = true;

    originalHref = window.location.href;

    $body.addClass("stop-scrolling");

    TweenMax.to($ajaxOverlay, 0.4, {
        autoAlpha: 1,
        yPercent: -100,
        ease: Power4.easeInOut,
        onComplete: openAjax,
        onCompleteParams: [ajaxHref]
    });

    TweenMax.to($closeAjaxButton, 0.3, {
        autoAlpha: 1,
        ease: Power4.easeInOut,
        delay: 0.5
    });

    history.pushState({}, "", ajaxHref);
}


//close ajax
$closeAjaxButton.on("click", function (e) {
    e.preventDefault();

    closeProject();
});

$body.on("click", ".js-chapter-nav-close", function(e){ 

    if (ajaxOpen == true) {
        e.preventDefault();
        closeProject();
    }
    
});



function closeProject() {

    ajaxOpen = false;

    $body.removeClass("stop-scrolling");

    $('.js-site-logo').removeClass("header__site-logo--dark");

    TweenMax.to($closeAjaxButton, 0.3, {
        autoAlpha: 0,
        ease: Power4.easeInOut
    });

    TweenMax.to($ajaxOverlay, 0.4, {
        autoAlpha: 0,
        yPercent: 0,
        ease: Power4.easeInOut,
        onComplete: emptyAjax
    });

    history.pushState({}, "", originalHref);

}

//history pop state
window.onpopstate = function () {
    $body.removeClass("stop-scrolling");

    if (ajaxOpen == true) {
        ajaxOpen = false;

        TweenMax.to($ajaxOverlay, 0.4, {
            autoAlpha: 0,
            yPercent: 0,
            ease: Power4.easeInOut,
            onComplete: emptyAjax
        });

        $closeAjaxButton.hide();

        history.pushState({}, "", originalHref);
    }
};

function openAjax(ajaxHref) {
    $ajaxHolder.load(ajaxHref + " #ajaxTarget", function () {
        projectCarousel = document.querySelector(".js-project-carousel");

        if (typeof projectCarousel != "undefined" && projectCarousel != null) {
            const projectChapters = projectCarousel.querySelectorAll(".project-chapter"),
                chapters = [],
                audioButton = projectCarousel.querySelector(".js-audio-button"),
                btsButton = projectCarousel.querySelector(".js-bts-button");

            createChapters(projectChapters, chapters);
            chapterNavigation(chapters);
            const firstChapterColor = chapters[0].color;
            chapterColor(firstChapterColor);

            const spotlights = document.querySelectorAll(".js-spotlight-rollover");

            spotlights.forEach((spotlight) => {
                spotlight.addEventListener("mousemove", spotlightMove);
                spotlight.addEventListener("mouseleave", spotlightLeave);

                let rect = spotlight.getBoundingClientRect();
                let center = {
                    w: Math.round(rect.width * 0.5),
                    h: Math.round(rect.height * 0.5)
                };
                let spot = spotlight.querySelector(".js-spotlight");

                TweenMax.set(spot, {
                    xPercent: -50,
                    yPercent: -50,
                    x: center.w,
                    y: center.h,
                    ease: Back.easeOut.config(1.4)
                });
            });

            const textChapters = document.querySelectorAll(".js-text-chapter");
            textChapters.forEach((chapter) => {
                textChapter(chapter);
            });

            if (typeof audioButton != "undefined" && audioButton != null) {
                projectAudio(audioButton);
            }

            if(typeof(btsButton) != 'undefined' && btsButton != null){
                behindTheScenes(btsButton);
            }

            videoElems = document.querySelectorAll(".inline-video");
            //console.log(videoElems.length);
            if (videoElems.length > 0) {
                inlineVideo(); 
            }

            ytVideoEmbeds = document.getElementsByClassName('js-embed-youtube'); 
            for (var i = 0; i < ytVideoEmbeds.length; i++) {
                var curplayer = createPlayer(ytVideoEmbeds[i]);
                 players[i] = curplayer;
            }
        }

        $ajaxHolder
            .imagesLoaded()
            .always(function () {
                //console.log('all images loaded');
            })
            .done(function () {
                //console.log("all good");
                $loader.fadeOut();
                loadTitle(projectCarousel);
            })
            .fail(function () {
                //console.log('error');
            });
    });
}

function emptyAjax() {
    $ajaxHolder.empty();
}
